import "./DataHub.css";

const DataHub = () => {
  return (
    <div className="data-hub">
      <section className="component-1">
        <img className="image-1-icon" alt="" src="/image-1@2x.png" style={{ filter: 'brightness(60%)' }} />
        <div className="image-component-container">
          <div className="cape-town-awaits-container">
            <div className="cape-town-awaits" style={{ color: 'white'}}>Cape Town Awaits!</div>
          </div>
          <div className="search-container">
            <div className="search-bar">
              <div className="search-bar-inner">
                <div className="frame-parent">
                  <div className="akar-iconssearch-parent">
                    <img
                      className="akar-iconssearch"
                      alt=""
                      src="/akariconssearch.svg"
                    />
                    <div className="search-destinations-hotels">
                      Search destinations, hotels, activities, flights
                    </div>
                  </div>
                  <div className="akar-iconscalendar-parent">
                    <img
                      className="akar-iconscalendar"
                      alt=""
                      src="/akariconscalendar.svg"
                    />
                    <div className="check-in">Check in</div>
                  </div>
                  <div className="akar-iconscalendar-group">
                    <img
                      className="akar-iconscalendar1"
                      alt=""
                      src="/akariconscalendar-1.svg"
                    />
                    <div className="check-out">Check out</div>
                  </div>
                  <div className="fontistomale-parent">
                    <img
                      className="fontistomale-icon"
                      alt=""
                      src="/fontistomale.svg"
                    />
                    <div className="room-2-adults">1 room, 2 adults</div>
                  </div>
                  <button className="search-wrapper">
                    <b className="search">Search</b>
                  </button>
                </div>
              </div>
            </div>
            <div className="categories-container">
              <b className="top-categories">Top categories</b>
            </div>
            <div className="category-images">
              <div className="category-image-grid">
                <div className="frame-group">
                  <div className="frame-container">
                    <div className="frame-div">
                      <div className="image-4-wrapper">
                        <img
                          className="image-4-icon"
                          loading="lazy"
                          alt=""
                          src="/image-4@2x.png"
                        />
                      </div>
                      <div className="beaches">Beaches</div>
                    </div>
                    <div className="frame-parent1">
                      <div className="image-16-wrapper">
                        <img
                          className="image-16-icon"
                          loading="lazy"
                          alt=""
                          src="/image-16@2x.png"
                        />
                      </div>
                      <div className="nature">Nature</div>
                    </div>
                    <div className="frame-parent2">
                      <div className="image-3-wrapper">
                        <img
                          className="image-3-icon"
                          loading="lazy"
                          alt=""
                          src="/image-3@2x.png"
                        />
                      </div>
                      <div className="mountains">Mountains</div>
                    </div>
                    <div className="frame-parent3">
                      <div className="image-13-wrapper">
                        <img
                          className="image-13-icon"
                          loading="lazy"
                          alt=""
                          src="/image-13@2x.png"
                        />
                      </div>
                      <div className="iconic-sites">Iconic Sites</div>
                    </div>
                    <div className="frame-parent4">
                      <div className="image-17-wrapper">
                        <img
                          className="image-17-icon"
                          loading="lazy"
                          alt=""
                          src="/image-17@2x.png"
                        />
                      </div>
                      <div className="hostels">Hostels</div>
                    </div>
                    <div className="frame-parent5">
                      <div className="image-10-wrapper">
                        <img
                          className="image-10-icon"
                          alt=""
                          src="/image-10@2x.png"
                        />
                      </div>
                      <div className="countyside">Hiking Trails</div>
                    </div>
                    <div className="frame-parent6">
                      <div className="image-5-wrapper">
                        <img
                          className="image-5-icon"
                          alt=""
                          src="/image-5@2x.png"
                        />
                      </div>
                      <div className="camping">Camping</div>
                    </div>
                    <div className="historical-place">
                      <img
                        className="image-12-icon"
                        alt=""
                        src="/image-12@2x.png"
                      />
                      <div className="historical-places">
                        <p className="historical">Historical</p>
                        <p className="places"> Places</p>
                      </div>
                    </div>
                    <div className="frame-parent7">
                      <div className="image-15-wrapper">
                        <img
                          className="image-15-icon"
                          alt=""
                          src="/image-15@2x.png"
                        />
                      </div>
                      <div className="meetups">Meetups</div>
                    </div>
                    <div className="frame-parent8">
                      <div className="image-8-wrapper">
                        <img
                          className="image-8-icon"
                          alt=""
                          src="/image-8@2x.png"
                        />
                      </div>
                      <div className="chillers">Chillers</div>
                    </div>
                  </div>
                  <div className="data-finder" />
                </div>
              </div>
              <div className="destinations">
                <b className="top-destinations">Top Destinations</b>
              </div>
            </div>
            <div className="frame-parent9">
              <div className="image-18-parent">
                <img
                  className="image-18-icon"
                  loading="lazy"
                  alt=""
                  src="/image-18@2x.png" style={{ filter: 'brightness(60%)' }}
                />
                <div className="bali-indonasia" style={{ fontWeight: 'bold'}} >{`V&A Waterfront`}</div>
              </div>
              <div className="image-18-group">
                <img
                  className="image-18-icon1"
                  alt=""
                  src="/image-18-1@2x.png" style={{ filter: 'brightness(60%)' }}
                />
                <div className="sea-point" style={{ fontWeight: 'bold'}}>Sea Point </div>
              </div>
              <div className="image-18-container">
                <img
                  className="image-18-icon2"
                  alt=""
                  src="/image-18-2@2x.png" style={{ filter: 'brightness(70%)' }}
                />
                <div className="clifton" style={{ fontWeight: 'bold'}}>Clifton</div>
              </div>
              <div className="image-18-parent1">
                <img
                  className="image-18-icon3"
                  alt=""
                  src="/image-18-3@2x.png"
                  style={{ filter: 'brightness(70%)' }}
                />
                <div className="hout-bay" style={{ fontWeight: 'bold'}}>Hout Bay</div>
              </div>
            </div>
          </div>
        </div>
        <header className="trvl-cape-instance">
          <img
            className="trvl-cape-1"
            loading="lazy"
            alt=""
            src="/trvl-cape-1@2x.png"
          />
          <div className="navbar">
            <div className="frame-parent10">
              <div className="home-wrapper">
                <a className="home">Home</a>
              </div>
              <div className="hotels-wrapper">
                <a className="hotels">Hotels</a>
              </div>
              <div className="flights-wrapper">
                <a className="flights">Flights</a>
              </div>
              <div className="packages-wrapper">
                <a className="packages">Packages</a>
              </div>
              <button className="sign-up-wrapper">
                <a className="sign-up">Sign Up</a>
              </button>
            </div>
          </div>
        </header>
      </section>
      <section className="offers-parent">
        <b className="offers">Offers</b>
        <div className="data-protector">
          <div className="data-protector-inner">
            <div className="frame-parent11">
              <div className="bytesizeheart-parent">
                <img
                  className="bytesizeheart-icon"
                  alt=""
                  src="/bytesizeheart.svg"
                />
                <img className="image-19-icon" alt="" src="/image-19@2x.png" />
              </div>
              <div className="frame-parent12">
                <div className="frame-parent13">
                  <div className="mango-parent">
                    <div className="mango">Mango</div>
                    <div className="frame-wrapper">
                      <div className="huge-savings-on-flight-with-ma-wrapper">
                        <div className="huge-savings-on">
                          Huge savings on flight with Mango Airlines.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="book-domestic-flights-starting-wrapper">
                    <div className="book-domestic-flights">
                      Book domestic flights starting @ just R790
                    </div>
                  </div>
                </div>
                <div className="frame-wrapper1">
                  <div className="book-now-wrapper">
                    <div className="book-now">Book Now</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="data-protector-child">
            <div className="frame-wrapper2">
              <div className="frame-parent14">
                <div className="bytesizeheart-group">
                  <img
                    className="bytesizeheart-icon1"
                    alt=""
                    src="/bytesizeheart.svg"
                  />
                  <img
                    className="image-19-icon1"
                    alt=""
                    src="/image-19@2x.png"
                  />
                </div>
                <div className="frame-parent15">
                  <div className="frame-parent16">
                    <div className="mango-group">
                      <div className="mango1">Mango</div>
                      <div className="frame-wrapper3">
                        <div className="huge-savings-on-flights-with-m-wrapper">
                          <div className="huge-savings-on1">
                            Huge savings on flights with Mango Airlines.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="book-domestic-flights-starting-container">
                      <div className="book-domestic-flights1">
                        Book domestic flights starting @ just R790
                      </div>
                    </div>
                  </div>
                  <div className="frame-wrapper4">
                    <button className="book-now-container">
                      <div className="book-now1">Book Now</div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="data-sharer">
            <div className="frame-parent17">
              <div className="bytesizeheart-container">
                <img
                  className="bytesizeheart-icon2"
                  alt=""
                  src="/bytesizeheart-2.svg"
                />
                <img
                  className="image-19-icon2"
                  alt=""
                  src="/image-19-2@2x.png"
                />
              </div>
              <div className="frame-parent18">
                <div className="frame-parent19">
                  <div className="the-silo-hotel-parent">
                    <div className="the-silo-hotel">The Silo Hotel</div>
                    <div className="frame-wrapper5">
                      <div className="enjoy-up-to-20-off-at-the-sil-wrapper">
                        <div className="enjoy-up-to-container">
                          <p className="enjoy-up-to-20-off-at">
                            <span className="enjoy-up-to">{`Enjoy up to `}</span>
                            <b className="b">20%</b>
                            <span className="off-at"> off at</span>
                          </p>
                          <p className="the-silo-hotel1">The Silo Hotel</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="make-the-most-of-this-deal-on-wrapper">
                    <div className="make-the-most-container">
                      <p className="make-the-most">{`Make the most of  this deal `}</p>
                      <p className="on-your-first">on your first booking.</p>
                    </div>
                  </div>
                </div>
                <div className="frame-wrapper6">
                  <button className="book-now-frame">
                    <div className="book-now2">Book Now</div>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="data-sharer1">
            <div className="frame-parent20">
              <div className="bytesizeheart-parent1">
                <img className="bytesizeheart-icon3" alt="" />
                <img
                  className="image-19-icon3"
                  alt=""
                  src="/image-19-3@2x.png"
                />
              </div>
              <div className="frame-parent21">
                <div className="frame-parent22">
                  <div className="bank-offer-parent">
                    <div className="bank-offer">Bank Offer</div>
                    <div className="frame-wrapper7">
                      <div className="get-upto-30-instant-discount-wrapper">
                        <div className="get-upto-30">
                          Get up to 30% instant discount
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="get-discount-on-flights-hotel-wrapper">
                    <p className="get-discount-on">
                      Get discount on flights, hotels and holiday packages with
                      HSBC Bank credit card.
                    </p>
                  </div>
                </div>
                <div className="frame-wrapper6">
                  <button className="book-now-frame">
                    <div className="book-now2">Book Now</div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="interests">
        <div className="interests-content">
          <div className="interests-header">
            <b className="browse-by-interests">Browse by Interests</b>
          </div>
          <div className="frame-parent23">
            <div className="image-18-parent2">
              <img className="image-18-icon4" alt="" src="/image-18-4@2x.png" style={{ filter: 'brightness(70%)' }} />
              <div className="hotels1">Hotels</div>
            </div>
            <div className="image-18-parent3">
              <img className="image-18-icon5" alt="" src="/image-18-5@2x.png" style={{ filter: 'brightness(60%)' }} />
              <div className="appartments">Activities</div>
            </div>
            <div className="image-18-parent4">
              <img className="image-18-icon6" alt="" src="/image-18-6@2x.png" style={{ filter: 'brightness(60%)' }} />
              <div className="yacht-cruises">Yacht Cruises</div>
            </div>
            <div className="image-18-parent5">
              <img className="image-18-icon7" alt="" src="/image-18-7@2x.png" style={{ filter: 'brightness(70%)' }} />
              <div className="restaurants">Restaurants</div>
            </div>
          </div>
        </div>
        <div className="travel-expert">
          <div className="data-backup">
            <img
              className="image-20-icon"
              loading="lazy"
              alt=""
              src="/image-20@2x.png" style={{ filter: 'brightness(50%)' }}
            />
            <div className="plan-your-trip-with-a-travel-e-wrapper">
              <p className="plan-your-trip">
                Let our travel experts help you plan the perfect trip to Cape
                Town.
              </p>
            </div>
            <div className="let-our-skilled">
              Let our skilled advisors craft a flawless itinerary for your
              journey.
            </div>
          </div>
        </div>
      </section>
      <section className="data-queue">
        <div className="community-content">
          <b className="connect-with-other">Explore Exclusive Deals!</b>
        </div>
        <div className="data-pool">
          <div className="data-stream">
            <img
              className="data-stream-child"
              loading="lazy"
              alt=""
              src="/frame-311@2x.png"
            />
            <div className="data-matrix">
              <div className="data-aggregator">
                <div className="condition-splitter">
                  <div className="table-mountain-cableway">
                    Table Mountain Cableway
                  </div>
                </div>
                <div className="table-mountain-national">
                  Table Mountain National Park
                </div>
                <div className="travellers" style={{ fontWeight: 'bold' }}>{`30% OFF `}</div>
              </div>
            </div>
          </div>
          <div className="data-stream1">
            <img className="data-stream-item" alt="" src="/frame-31-1@2x.png" />
            <div className="data-stream-inner">
              <div className="frame-parent24">
                <div className="oneonly-cape-town-wrapper">
                  <div className="oneonly-cape-town">{`One&Only Cape Town`}</div>
                </div>
                <div className="the-marina-victoria">{`The Marina, Victoria & Alfred Waterfront `}</div>
                <div className="travellers1" style={{ fontWeight: 'bold' }}>25% OFF</div>
              </div>
            </div>
          </div>
          <div className="recommendation">
            <div className="data-stream2">
              <img className="frame-icon" alt="" src="/frame-31-2@2x.png" />
              <div className="data-stream-inner1">
                <div className="frame-parent25">
                  <div className="cape-luxury-car-rentals-wrapper">
                    <div className="cape-luxury-car">
                      Cape Luxury Car Rentals
                    </div>
                  </div>
                  <div className="car-rental-company">Car Rental Company</div>
                  <div className="travellers2" style={{ fontWeight: 'bold' }}>15% OFF</div>
                </div>
              </div>
            </div>
            <div className="helicopter">
              <div className="data-stream3">
                <img
                  className="data-stream-child1"
                  alt=""
                  src="/frame-31-3@2x.png"
                />
                <div className="data-stream-inner2">
                  <div className="frame-parent26">
                    <div className="waterfront-helicopters-wrapper">
                      <div className="waterfront-helicopters">
                        Waterfront Helicopters
                      </div>
                    </div>
                    <div className="va-waterfront">{`V&A Waterfront`}</div>
                    <div className="travellers3" style={{ fontWeight: 'bold' }}>25% OFF</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="image-processor">
        <img className="image-21-icon" alt="" src="/image-21@2x.png" style={{ filter: 'brightness(50%)' }}/>
        <div className="iphone-mockup">
          <img className="shadow-icon" alt="" src="/shadow@2x.png" />
          <img
            className="iphone-13-mockup-label"
            loading="lazy"
            alt=""
            src="/iphone-13-mockup-label@2x.png"
          />
        </div>
        <div className="image-processor-child" />
        <div className="image-processor-item" />
        <div className="app-description">
          <div className="slogan">
            <div className="app-slogan">
              <b className="your-cape-town">
                Your Cape Town travel companion App.
              </b>
            </div>
            <div className="description">
              <div className="app-description1">
                <p className="your-gateway-to">
                  Your gateway to Cape Town! Quickly book flights, hotels,
                  shuttles, and rental cars. Enjoy real-time updates, exclusive
                  deals on our app!
                </p>
              </div>
              <div className="download">
                <div className="download-options">
                  <div className="function-call-tree">
                    <div className="function-call-stack">
                      <div className="mobile-wrapper">
                        <a className="mobile">Mobile</a>
                      </div>
                      <div className="email-wrapper">
                        <div className="email">Email</div>
                      </div>
                    </div>
                    <div className="function-call-graph">
                      <p className="enter-your-phone">
                        Enter your phone number to receive a text with a link to
                        download the app.
                      </p>
                      <div className="function-call-web">
                        <div className="function-call-matrix">
                          <div className="function-call-grid">
                            <div className="div">+27</div>
                            <div className="mobile-number">Mobile number</div>
                          </div>
                          <button className="function-call-jungle">
                            <b className="search1">Search</b>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="app-store-buttons">
                  <img
                    className="image-22-icon"
                    loading="lazy"
                    alt=""
                    src="/image-22@2x.png"
                  />
                  <div className="play-store-button">
                    <img
                      className="image-23-icon"
                      loading="lazy"
                      alt=""
                      src="/image-23@2x.png"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer className="footer">
        <div className="content">
          <div className="links-parent">
            <div className="links">
              <div className="about">
                <div className="seslendirme-ve-alt">About Cape Town</div>
                <div className="medya-merkezi">Top Attractions</div>
                <div className="gizlilik">Local Events</div>
                <div className="bize-ulan">Travel Guides</div>
              </div>
              <div className="link-columns">
                <a className="sesli-betimleme">Flights</a>
                <div className="hotels2">Hotels</div>
                <div className="yasal-hkmler">Travel Packages</div>
              </div>
              <div className="link-columns1">
                <div className="yardm-merkezi">FAQs</div>
                <div className="mkanlar">Manage Booking</div>
                <div className="erez-tercihleri">Refund Policy</div>
              </div>
              <div className="link-columns2">
                <a className="hediye-kartlar">About Us</a>
                <a className="kullanm-koullar">Careers</a>
                <a className="kurumsal-bilgiler">Partners</a>
              </div>
            </div>
            <div className="social">
              <button className="hizmetkodubutton">
                <div className="hizmet-kodu">Contact Us</div>
              </button>
              <div className="social-media">
                <div className="icons">
                  <img
                    className="facebook-icon"
                    loading="lazy"
                    alt=""
                    src="/facebook.svg"
                  />
                  <img
                    className="instagram-icon"
                    loading="lazy"
                    alt=""
                    src="/instagram.svg"
                  />
                  <img
                    className="twitter-icon"
                    loading="lazy"
                    alt=""
                    src="/twitter.svg"
                  />
                  <img
                    className="youtube-icon"
                    loading="lazy"
                    alt=""
                    src="/youtube.svg"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="trvl-cape">© 2025 Trvl Cape</div>
        <img className="trvl-cape-3-1" alt="" src="/trvl-cape-3-1@2x.png" />
      </footer>
    </div>
  );
};

export default DataHub;
